// Unit Points (UP) — the per-team spawn economy. Each team owns one UnitBank that regenerates UP
// over time (balance.upRegen) up to a cap, and pays UP to field non-free units (ranged soldiers,
// giants, tanks). The plain melee infantryman is free, so the field fills with cheap filler while
// specials are gated by the bank. Army + Tanks share the SAME two banks (one per team).

import { balance } from "./balance";

export class UnitBank {
  up: number;

  constructor(start = balance.upStart) {
    this.up = start;
  }

  /** Accrue UP over time (call once per frame with dt seconds). */
  tick(dt: number): void {
    this.up = Math.min(balance.upCap, this.up + balance.upRegen * dt);
  }

  /** Reset to the starting stipend (a fresh level restarts the economy). */
  reset(): void {
    this.up = balance.upStart;
  }

  canAfford(cost: number): boolean {
    return this.up >= cost;
  }

  /** Deduct a cost (clamped at 0). Only call after canAfford / at the actual spawn commit. */
  spend(cost: number): void {
    this.up = Math.max(0, this.up - cost);
  }
}

/** Placeholder tank UP cost from its base hp (bigger/tankier = pricier). Tuned systematically later. */
export function tankUnitCost(baseHp: number): number {
  return Math.round(35 + baseHp * 0.7);
}
